import { render } from "./MoveUserDialog.vue?vue&type=template&id=637e01ac&scoped=true"
import script from "./MoveUserDialog.vue?vue&type=script&lang=js"
export * from "./MoveUserDialog.vue?vue&type=script&lang=js"

import "./MoveUserDialog.vue?vue&type=style&index=0&id=637e01ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637e01ac"]])

export default __exports__